module.exports = __webpack_public_path__ + "img/qc-lab.034c95bc.jpg";